module.exports = __webpack_public_path__ + "static/media/19ESCAP48.8d6f9a0c.jpg";